import * as React from 'react';
import { cn } from '@/lib/utils';

type Orientation = 'horizontal' | 'vertical';

interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: Orientation;
  decorative?: boolean;
}

const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ className, orientation = 'horizontal', decorative = false, role, ...props }, ref) => {
    const ariaOrientation = orientation === 'vertical' ? 'vertical' : undefined;
    const resolvedRole = decorative ? 'presentation' : role ?? 'separator';

    return (
      <div
        ref={ref}
        className={cn(
          'shrink-0 bg-border',
          orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
          className,
        )}
        role={resolvedRole}
        {...(ariaOrientation ? { 'aria-orientation': ariaOrientation } : {})}
        {...props}
      />
    );
  },
);

Separator.displayName = 'Separator';

export { Separator };
